import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tag",
  "use": "icon-tag-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-tag\"><path d=\"M864 128 545.28 128C534.4 126.08 522.88 129.28 514.56 137.6l-441.6 441.6C65.28 586.88 62.72 597.12 63.36 606.72 62.72 616.96 65.28 627.2 72.96 634.88l313.6 313.6c7.68 7.68 17.92 10.88 27.52 9.6 10.24 1.28 21.12-1.92 28.8-9.6l441.6-441.6c3.84-3.84 6.4-8.96 8.32-14.08C894.72 488.96 896 484.48 896 480l0-320C896 142.08 881.92 128 864 128zM832 460.16 414.72 876.8 144.64 606.72 560 192 832 192 832 460.16zM640 448c35.2 0 64-28.8 64-64 0-35.2-28.8-64-64-64C604.8 320 576 348.8 576 384 576 419.2 604.8 448 640 448z\" p-id=\"2807\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/tag.svg
// module id = 0dAG
// module chunks = 30